class HemavError extends Error {
  constructor({ message, code, metadata }) {
    super(message)
    this.isHemavError = true
    this.code = code
    this.metadata = metadata
  }
}

export const isHemavError = error => {
  return error instanceof HemavError
}

export const isHemavErrorWithCode = (error, code) => {
  return isHemavError(error) && error.code === code
}

export const createHemavError = ({ message, code, metadata = {} }) => {
  if (!code) {
    throw new Error('error code is required to create this error')
  }
  return new HemavError({ message: message || code, code, metadata })
}

export const ERROR_CODES = {
  GEOMETRY_TOO_COMPLEX_TO_PROCESS: 'geometry-too-complex-to-process',
  ERROR_PROCESSING_DELIVERABLE: 'error-processing-deliverable',
  ERROR_INVALID_SCALE: 'error-invalid-scale',
  ERROR_FETCHING_S3_URL: 'error-fetching-s3-url'
}
